import React from 'react';
import {
  Collapse as ReactCollapse,
  CollapseProps,
  UnmountClosed,
} from 'react-collapse';

import type { TPAComponentProps } from 'wix-ui-tpa/dist/cssVars/types/types';

import classes from './Collapse.scss';

type ReactCollapseTheme = CollapseProps['theme'];

interface IProps extends CollapseProps, TPAComponentProps {
  unmountOnExit?: boolean;
}

export function Collapse(props: IProps) {
  const { unmountOnExit, ...rest } = props;

  const Component = unmountOnExit ? UnmountClosed : ReactCollapse;

  return <Component theme={classes as ReactCollapseTheme} {...rest} />;
}

Collapse.displayName = 'wui/Collapse';
